const projects = [
    {
        id: 1,
        img: 'https://i.ibb.co/x5T86tn/dronezz.png',
        title: 'Dronezz',
        subTitle: 'A niche product site',
        des: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Accusantium, numquam?',
        live: 'https://wefit-5db49.web.app/',
        screebShots: [
            "https://i.ibb.co/cN2dqw9/1.png",
            "https://i.ibb.co/mFhzc54/2.png",
            "https://i.ibb.co/0std9fx/3.png",
            "https://i.ibb.co/bdQBPT2/4.png",
            "https://i.ibb.co/LxTCJHx/5.png",
            "https://i.ibb.co/ZX4sMvb/6.png",
            "https://i.ibb.co/Wn9m9YH/7.png",
            "https://i.ibb.co/Y3P8yq3/8.png"
        ],
        details: [
            `This is a drone selling site. Users can choose and purchase drones from many options.`,
            `Users must have to authenticate before purchasing any item. Authenticated users can manage their orders,  give rating and feedback.`,
            `This site has an  Admin dashboard too. Admin can manage inventory like add new products, delete products, update order status, delete orders etc.Admin can give admin roles to any user by their email. `,
            `{  Test Admin email:  admin@admin.com  password: 123456  }`
        ],
        technologyUsed: 'React, Material-UI , Firebase, Node.js, Express, MongoDB'

    },
    {
        id: 2,
        img: 'https://github.com/foysalBN/WeFit-healthcare-related-site/raw/main/src/img/ss1.png',
        title: 'WeFit',
        subTitle: 'Healthcare related site',
        des: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Accusantium, numquam?',
        live: 'https://wefit-5db49.web.app/',
        screebShots: [
            "https://i.ibb.co/zJgGXcG/1.png",
            "https://i.ibb.co/Qf6P8Nj/2.png",
            "https://i.ibb.co/L5gDynT/3.png"
        ],
        details: [
            `Gym and health Care related service provider site. Users can join different kinds of fitness training and Gym services.`,
            `Users can login with google or  email & password.`
        ],
        technologyUsed: `React, Bootstrap , Firebase, Node.js, Express, MongoDB`

    },
    {
        id: 3,
        img: 'https://i.ibb.co/0X4QXhG/image.png',
        title: 'Adventure Lovers',
        subTitle: 'Tourism Service provider site',
        des: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Accusantium, numquam?',
        live: 'https://wefit-5db49.web.app/',
        screebShots: [
            'https://i.ibb.co/0X4QXhG/image.png',
            'https://i.ibb.co/Q6PfdfW/2.png',
            'https://i.ibb.co/yQxz1pc/3.png',
            'https://i.ibb.co/tzW5227/4.png',
            'https://i.ibb.co/BZQFw5J/5.png',
        ],
        details: [
            `This is a tourism agency website. Users can choose a destination from various options. Authenticated users can manage their bookings. They can delete or confirm a tour after placing their bookings.`,
            `Admin can add new services and manage orders.`
        ],
        technologyUsed: `React, Bootstrap , Firebase, Node.js, Express, MongoDB`
    },
]

export default projects;
